// extracted by mini-css-extract-plugin
module.exports = {"title":"GoodToKnow_title__Cdb49","text":"GoodToKnow_text__cleaa","poweredBy":"GoodToKnow_poweredBy__4_NeA","disclaimer":"GoodToKnow_disclaimer__LMJ9p"};